import { Channel } from '../../types/ChannelType';

import { AddressType } from '../../types/AddressType';
import getDisplayName from '../getDisplayName';
import { constructChannel } from './constructChannel';

export function cloneChannel(
  cloneFrom: Channel,
  location: AddressType,
  parent: Channel,
  userId: string
): Channel {
  // use the construct channel to make a fully formed channel object
  const newChannel = constructChannel({
    userId,
    parent,
  });

  // @ts-expect-error TS-10761 FIXME: Incompatible API Type for `Channel` expectation.
  delete newChannel._id;

  // take the address of the location channel
  newChannel.address = { ...location };

  // remove the existing id
  // @ts-expect-error TS-10761 FIXME: Incompatible API Type for `Channel` expectation.
  delete newChannel.address._id;

  // copy the settings, profile from the copyFrom channel
  // @ts-expect-error TS-10761 FIXME: Incompatible API Type for `Channel` expectation.
  newChannel.profile = {
    ...cloneFrom!.profile,
    name: `${getDisplayName(cloneFrom)} - Copy`,
  };

  // remove the existing profile id
  // @ts-expect-error TS-10761 FIXME: Incompatible API Type for `Channel` expectation.
  delete newChannel.profile?._id;

  // if there is content in the profile, flatten it down.
  if (newChannel.profile?.content) {
    // @ts-expect-error TS-10761 FIXME: Incompatible API Type for `Channel` expectation.
    newChannel.profile.content = {
      _id: newChannel.profile.content._id,
    };
  }

  if (newChannel.profile?.theme) {
    // @ts-expect-error TS-10761 FIXME: Incompatible API Type for `Channel` expectation.
    newChannel.profile.theme = {
      _id: newChannel.profile.theme._id,
    };
  }

  return {
    ...newChannel,
    name: cloneFrom.name,
    type: cloneFrom.type,
    experienceType: cloneFrom.experienceType,
    website: cloneFrom.website,
    description: cloneFrom.description,
    parent: parent ? { _id: parent._id } : null,
    slug: `${cloneFrom.slug}-copy`,
    isPublic: cloneFrom.isPublic,
    isDiscoverable: cloneFrom.isDiscoverable,
    isLive: cloneFrom.isLive,
    isSub: cloneFrom.isSub,
    hasCustomOffboarding: cloneFrom.hasCustomOffboarding,
    inviteOnly: cloneFrom.inviteOnly,
    filters: cloneFrom.filters,
    tags: cloneFrom.tags,
    settings: {
      maxUsers: cloneFrom.settings.maxUsers,
      subscribersJoinParent: cloneFrom.settings.subscribersJoinParent,
      subscribersAreDecoyed: cloneFrom.settings.subscribersAreDecoyed,
      // don't copy join rules. this wouldn't make sense on a new channel
      groupRoleJoinRules: [],
      hasPerksEnabled: cloneFrom.settings.hasPerksEnabled,
      hasBillingPaymentsEnabled: cloneFrom.settings.hasBillingPaymentsEnabled,
      hasWorkOrdersEnabled: false,
      hasWorkOrderServiceRequestsEnabled: false,
      hasWorkOrderPreventiveMaintenanceEnabled: false,
      hasWorkOrderEquipmentEnabled: false,
      hasWorkOrderCrossPropertyEnabled: false,
      hasVisitorManagementEnabled:
        cloneFrom.settings.hasVisitorManagementEnabled,
      hasHardwareManagementEnabled:
        cloneFrom.settings.hasHardwareManagementEnabled,
      hasHardwarePinManagementEnabled:
        cloneFrom.settings.hasHardwarePinManagementEnabled,
      hasReservableManagementEnabled:
        cloneFrom.settings.hasReservableManagementEnabled,
      hasAccessControlEnabled: cloneFrom.settings.hasAccessControlEnabled,
      hasSurveysEnabled: cloneFrom.settings.hasSurveysEnabled,
      areUserTemplatesAllowed: cloneFrom.settings.areUserTemplatesAllowed,
      channelLanguages: cloneFrom.settings.channelLanguages,
      enabledLanguagesForMembers: cloneFrom.settings.enabledLanguagesForMembers,
      multiLanguageEnabled: cloneFrom.settings.multiLanguageEnabled,
      offboardingDelayDays: cloneFrom.settings.offboardingDelayDays,
      hasMessagingAndMarketplaceEnabled:
        cloneFrom.settings.hasMessagingAndMarketplaceEnabled,
      hasSmartUserManagementEnabled:
        cloneFrom.settings.hasSmartUserManagementEnabled,
    },
    stats: {
      subscribers: cloneFrom.stats?.subscribers ?? 1,
      sf: cloneFrom.stats?.sf ?? 1,
    },
  };
}

export default cloneChannel;
